import { useMemo } from 'react'
import { useAnnotationQueryVariables } from '../context'
import useGetAnnotations from '../operations/useGetAnnotations'
import {
  GetAnnotationsQueryVariables,
  BaseAnnotationFragment,
} from '@sketch/gql-types'

const EMPTY_ARRAY = [] as const
const OPTIMISTIC_FILTER = () => true

type UseHasNewNotificationsOptions = {
  skip?: boolean
  filter?: (entry: BaseAnnotationFragment) => boolean
}

export function useHasNewNotifications({
  skip,
  filter = OPTIMISTIC_FILTER,
}: UseHasNewNotificationsOptions = {}) {
  const variables = useAnnotationQueryVariables('sidebar')
  const queryVariables = {
    ...variables,
    sort: 'NEW_FIRST',
    annotationStatus: 'ACTIVE_ONLY',
  } as GetAnnotationsQueryVariables

  const skipQuery = !(
    (variables.subjects?.length || 0) > 0 || variables.subject
  )

  const { data } = useGetAnnotations({
    variables: queryVariables,
    skip: skip || skipQuery,
  })

  const annotations = data?.annotations.entries || EMPTY_ARRAY

  return useMemo(
    () =>
      annotations.some((entry: BaseAnnotationFragment) => {
        return (entry.isNew || entry.hasNewComments) && filter(entry)
      }),
    [annotations, filter]
  )
}
